<template>
    <div>
        <div class="form-group">
            <label for="emailLogin">{{title}}</label>
            <span class="invalid-feedback">
                {{errorMsg}}
            </span>
            <input type="text" @focus="removeReadonly($event)" readonly ref="username" name="loginusername" class="form-control" v-model="username" :class="{'has-error' : errorMsg}" @input="updateUsername()" @blur="getUsersForEmail()">
        </div>
        <div class="overlay-back" v-if="usernames.length">
            <div class="usernames" :class="{'mobile': isMobile(), 'desktop': isDesktop()}">
                <div class="text-center">
                    <p>
                        <span v-html="$tc('you_have_multiple_usernames', usernames.length)"></span><br/>
                        <b>{{$t('choose_login_account')}}</b>
                    </p>
                </div>

                <div class="list">
                    <div class="card" v-for="user in usernames" v-on:click="chooseUsername(user)">
                        <div class="card-body">
                            {{user}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'Username',
    props: {
        value: '',
        title: '',
        errorMsg: ''
    },
    data: function() {
        return {
            username: '',
            usernames: [],
            loading: false,
            typed: false
        }
    },
    methods: {

        setTyped() {
            this.typed = true;
        },

        updateUsername() {
            this.setTyped();

            this.$emit('input', {
                value: this.username
            })
        },

        getUsersForEmail() {

            if(!this.typed) {
                return false;
            }

            this.loading = true;

            this.usernames = [];

            this.$axios.post('usernames', {'email': this.username}).then(response => {
                this.usernames = response.data.usernames;
                this.loading = false;
                this.$emit('unlock-btn');
            }).catch(err => {
                this.loading = false;
            });
        },

        chooseUsername(user) {

            this.username = user;

            this.usernames = [];

            this.$emit('input', {
                value: this.username
            })
        },

        removeReadonly(el) {
            el.target.removeAttribute('readonly');
        }
    }
}
</script>

<style lang="scss" scoped>

input{
    border: 1px solid #C7C7C6;
    border-radius: 4px;
    padding: 10px 20px;
    background: white !important;

    font-weight: 500;
    height: 50px;
    margin-bottom: 30px;
}
label{
    font-weight: 500;
}

.usernames {

    position: absolute;
    bottom: 0px;
    padding: 20px;
    border-radius: 20px;
    background: white;
    width: 100%;

    &.mobile {
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }

    &.desktop {

        max-width: 500px;
        margin: 0 auto;
        left: calc(50% - 250px);
        bottom: auto;
        top: 20%;

        .list {
            height: 300px;
        }
    }

    .list {
        margin-top: 20px;
        max-height: 250px;
        overflow-y: auto;
    }

    .card {
        margin-bottom: 10px;
        cursor: pointer;
        height: auto;
    }
}

</style>
